import { CSSObject } from '@chakra-ui/react';
import bgDesktop from '@/assets/gigabet/images/onboarding/onboardingAside.png';
import bgMobile from '@/assets/gigabet/images/onboarding/onboardingAsideMb.png';

export const WrapperAside: CSSObject = {
  bg: [`url(${bgMobile})`, null, `url(${bgDesktop}), #D79200`],
  bgSize: ['cover', null, 'contain'],
  bgRepeat: ['no-repeat', null, 'no-repeat'],
  display: 'flex',
  flexDir: 'column',
  px: [null, null, '10px'],
  borderBottom: ['3px', null, 'unset'],
  borderBottomColor: ['beta.500', null, 'unset'],
  h: ['50vw', '55vw', 'full'],
  borderLeftRadius: [null, null, '10px'],
  borderRightRadius: ['unset'],
  pt: ['4', null, '6'],
  flex: 1,
  a: {
    h: 40,
    img: {
      pos: 'absolute',
      maxW: ['38vw', null, '200px'],
      top: ['50px', null, '260px'],
      left: ['32%', null, '50px'],
    },
  },
};
